import { gql } from "@apollo/client";import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useRef, useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import CheckIcon from '@mui/icons-material/Check';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadIcon from '@mui/icons-material/Download';
import toast, { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import DocumentViewer from '../../../components/DocumentViewer';
import { APPCONFIG } from '../../../app.config';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import ErrorDialog from '../../../components/ErrorDialog';
import { CircularProgress } from "@mui/material";
import fileDownload from 'js-file-download';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { CustomButton } from '../../../components/customButton/CustomButton';

export default function Referenciados() {
  const RESULTADO_VALIDACION_OK = 'OK';

  const COLOR_OK = 'green';
  const COLOR_ERROR = 'red';

  const [result, setResult] = useState('');
  const [data, setData] = useState([]);
  const [colorMsg, setCologMsg] = useState('');
  const [disabledBtnValidar, setDisabledBtnValidar] = useState(false);
  const [showGrilla, setShowGrilla] = useState(false);
  const [accion, setAccion] = useState('');

  // upload
  const [fileSelected, setFileSelected] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);

  // dlg visualización
  const [filePreview, setFilePreview] = useState([]);
  const [openDlg, setOpenDlg] = useState(false);

  // dlg confimración
  const [openDlgConfirm, setOpenDlgConfirm] = useState(false);

  // Log de errores
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  let toastId = 0;
  const textInputFormulario = useRef(null);

  const Input = styled('input')({
    display: 'none'
  });

  const [formValues, setFormValues] = useState({
    Formulario: '',
    Talonario: ''
  });

  useEffect(() => {
    textInputFormulario.current.focus();
  }, []);

  const handleChangeTalonario = (event) => {
    const { value } = event.target;
    const regex = new RegExp("[0-9]+$");
    if (regex.test(value)) {
      setFormValues({
        ...formValues,
        Talonario: value
      });
    } else if (value === '') {
      setFormValues({
        ...formValues,
        Talonario: ''
      });
    }
  };

  const handleBlurTalonario = () => {
    if (formValues.Talonario !== "") {
      setFormValues({
        ...formValues,
        Talonario: String(formValues.Talonario).padStart(10, "0")
      });
    }
  };

  const QExisteReferenciaTalonario = gql`
        query QExisteReferenciaTalonario ($referencia: String!, $talonario: String!) {
            existeReferenciaTalonario
            (
                referencia: $referencia,
            talonario: $talonario,
            ) 
            {
                success,
                error,
                valorEsperado 
            }
        }`;

  const [getExisteTalonario, { data: dataExisteTalonario, error: errorExisteTalonario }] = useLazyQuery(QExisteReferenciaTalonario, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataExisteTalonario) return;
    if (dataExisteTalonario.existeReferenciaTalonario.success) {
      const valor = dataExisteTalonario.existeReferenciaTalonario.valorEsperado;
      setResult(valor);
      if (valor === RESULTADO_VALIDACION_OK) {
        setDisabledBtnValidar(true);
        setCologMsg(COLOR_OK);

        // cargo si tiene un archivo ya asociado
        getDocumentoAsociado(formValues.Formulario, formValues.Talonario);
      } else {
        setCologMsg(COLOR_ERROR);

        // limpio la grilla
        setData([]);
      }
    } else {
      setCologMsg(COLOR_ERROR);
      setResult("ERROR: no fue posible validar el Talonario.");
      setMensajeError(dataExisteTalonario.existeReferenciaTalonario.error);
    }
  }, [dataExisteTalonario]);

  useEffect(() => {
    if (!errorExisteTalonario) return;
    setCologMsg(COLOR_ERROR);
    setResult("ERROR: no fue posible validar el Talonario.");
    setMensajeError("ERRORDB");
  }, [errorExisteTalonario]);


  // valida en la base de datos la existencia de la combinación referencia (formulario) y el talonario
  // Pre-condición: parámetros ya validados físicamente, llegan a la función con valores.
  const existeTalonario = (formulario, talonario) => {
    getExisteTalonario({ variables: { referencia: formulario, talonario: talonario, idConsulta: Math.random() } });
  };

  const isValid = () => {
    let resultado = true;
    let mensaje = RESULTADO_VALIDACION_OK;

    // Formulario
    if (formValues.Formulario === "") {
      return {
        resultado: false,
        mensaje: "El Formulario es obligatorio."
      };
    }

    if (formValues.Formulario.length < 4) {
      return {
        resultado: false,
        mensaje: "El Formulario debe estar conformado por 4 caracteres."
      };
    }

    // Talonario
    if (formValues.Talonario === "") {
      return {
        resultado: false,
        mensaje: "El Talonario es obligatorio."
      };
    }

    if (formValues.Talonario.length < 10) {
      return {
        resultado: false,
        mensaje: "La longitud de Talonario debe ser de 10 caracteres."
      };
    }

    return { success: resultado, mensaje: mensaje };
  };

  const clickCheck = () => {
    const validacion = isValid();
    if (validacion.success) {
      // valido en la base la existencia del talonario
      existeTalonario(formValues.Formulario, formValues.Talonario);
    } else {
      setResult(validacion.mensaje);
      setCologMsg(COLOR_ERROR);
    }
  };

  const clickClear = () => {
    setFormValues({
      Formulario: "",
      Talonario: ""
    });
    textInputFormulario.current.focus();
    setResult("");
    setDisabledBtnValidar(false);
    setShowGrilla(false);
  };

  const handleChangeFormulario = (event) => {
    const { value } = event.target;
    const regex = new RegExp("^[a-zA-Z]+$");
    if (regex.test(value)) {
      setFormValues({
        ...formValues,
        Formulario: value.toUpperCase()
      });
    } else if (value === '') {
      setFormValues({
        ...formValues,
        Formulario: ''
      });
    }
  };

  // INICIO - DOCUMENTO ASOCIADO 

  const QGetArchivo = gql`
        query QGetArchivo ($referencia: String!, $talonario: String!) {
            archivoVisitas 
            (
                referencia: $referencia,
                talonario: $talonario,
            ) 
            {
                success,
                error,
                valorEsperado {
                    idArchivo,
                    titulo,
                    extension,
                    contentType,
                    archivo,
                    nroTalonario,
                    referenciaFormulario,
                    fechaAlta
                } 
            }
        }`;

  const [getArchivoQuery, { data: dataFile, error: errorFile }] = useLazyQuery(QGetArchivo, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataFile) return;
    toast.dismiss(toastId);
    if (dataFile.archivoVisitas.success) {
      setShowGrilla(true);
      if (accion === 'VIEW') {
        setFilePreview(dataFile.archivoVisitas.valorEsperado[0]);
        setOpenDlg(true);
      }

      if (accion === 'DOWNLOAD') {
        const arr = new Uint8Array(dataFile.archivoVisitas.valorEsperado[0].archivo);
        const documento = new Blob([arr], { type: dataFile.archivoVisitas.valorEsperado[0].contentType });
        const fileName = dataFile.archivoVisitas.valorEsperado[0].titulo + dataFile.archivoVisitas.valorEsperado[0].extension;

        fileDownload(documento, fileName);
      }

      if (accion === 'BORRAR') {
        setOpenDlgConfirm(true);
      }

    } else {
      setMensajeError(dataFile.archivoVisitas.error);
    }
  }, [dataFile]);

  useEffect(() => {
    if (!errorFile) return;
    toast.dismiss(toastId);
    setMensajeError("ERRORDB");
  }, [errorFile]);

  const QGetTituloArchivoVisitas = gql`
        query QGetTituloArchivoVisitas ($referencia: String!, $talonario: String!) {
            tituloArchivoVisitas 
            (
                referencia: $referencia,
                talonario: $talonario,
            ) 
            {
                success,
                error,
                valorEsperado {
                    idArchivo,
                    titulo,
                    extension,
                    contentType,
                    nroTalonario,
                    referenciaFormulario,
                    fechaAlta
                } 
            }
        }`;

  const [getDocumentoAsociadoQuery, { data: dataDoc, error: errorDoc }] = useLazyQuery(QGetTituloArchivoVisitas, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDoc) return;
    toast.dismiss(toastId);
    if (dataDoc.tituloArchivoVisitas.success) {
      setShowGrilla(true);
      setData(dataDoc.tituloArchivoVisitas.valorEsperado);
    } else {
      setMensajeError(dataDoc.tituloArchivoVisitas.error);
    }
  }, [dataDoc]);

  useEffect(() => {
    if (!errorDoc) return;
    toast.dismiss(toastId);
    setMensajeError("ERRORDB");
  }, [errorDoc]);


  const getDocumentoAsociado = (formulario, talonario) => {
    setData([]);
    // toastId = toast.loading('Cargando...', { id: 'clipboard' });
    getDocumentoAsociadoQuery({ variables: { referencia: formulario, talonario: talonario, idConsulta: Math.random() } });
  };

  const getArchivo = (formulario, talonario) => {
    //toastId = toast.loading('Cargando...', { id: 'clipboard' });
    getArchivoQuery({ variables: { referencia: formulario, talonario: talonario, idConsulta: Math.random() } });
  };

  // FIN - DOCUMENTO ASOCIADO

  // INICIO - SUBIR DOCUMENTO

  const MSubirDocumento = gql`
        mutation MSubirDocumento (
            $referencia: String!, $talonario: String!, $contentType: String!, $titulo: String!, $archivo: [Byte!]!, $extension: String!) {
            subirDocumento 
            (
                referencia: $referencia,
                talonario: $talonario,
                contentType: $contentType,
                titulo: $titulo,
                archivo: $archivo,
                extension: $extension,
            )
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [subirDocumento, { data: dataSubirDocumento }] = useMutation(MSubirDocumento, {
    onCompleted: (dataSubirDocumento) => {
      if (dataSubirDocumento.subirDocumento.success) {
        if (dataSubirDocumento.subirDocumento.valorEsperado) {
          getDocumentoAsociado(formValues.Formulario, formValues.Talonario);
        } else {
          // TODO: ANALIZAR CUANDO EJECUTARÍA ESTO
          toast.error(dataSubirDocumento.subirDocumento.error);
          toast.dismiss(toastId);
        }
      } else {
        setMensajeError(dataSubirDocumento.subirDocumento.error);
        toast.dismiss(toastId);
      }
    },
    onError: (dataSubirDocumento) => {
      setMensajeError("ERRORDB");
      toast.dismiss(toastId);
    }
  });

  const handleChangeFile = (event) => {
    //toastId = toast.loading('Cargando...', { id: 'clipboard' });
    setShowGrilla(false);
    setFileSelected(event.target.files[0]);
    setIsFilePicked(true);
  };

  const isValidTipoArchivoAdjunto = () => {
    let sizeFile = fileSelected.size;
    if (sizeFile > APPCONFIG.SIZEARCHIVO.REFERENCIADO.SIZE) {
      return -1;
    }

    return APPCONFIG.TIPOADJUNTO.REFERENCIADO.some((e) => e === fileSelected.type);
  };

  useEffect(() => {
    if (isFilePicked) {
      let isValido = isValidTipoArchivoAdjunto();
      if (isValido > 0) {
        const reader = new FileReader();
        const fileByteArray = [];
        reader.readAsArrayBuffer(fileSelected);
        reader.onloadend = (evt) => {
          if (evt.target.readyState === FileReader.DONE) {
            const arrayBuffer = evt.target.result,
              array = new Uint8Array(arrayBuffer);
            for (const a of array) {
              fileByteArray.push(a);
            }

            subirDocumento({
              variables: {
                referencia: formValues.Formulario,
                talonario: formValues.Talonario,
                titulo: formValues.Talonario,
                contentType: fileSelected.type,
                extension: "." + fileSelected.name.split(".")[1],
                archivo: fileByteArray
              }
            });
          }
        };


      } else {
        setShowGrilla(true);
        isValido == 0 ? toast.error("El tipo de archivo adjunto no está permitido.") :
        toast.error("El tamaño del archivo adjunto no está permitido, su máximo permitido es: " + APPCONFIG.SIZEARCHIVO.REFERENCIADO.INFO);
      }
      setIsFilePicked(false);
    }
  }, [isFilePicked]);

  // FIN - SUBIR DOCUMENTO

  // INICIO - ELIMINAR DOCUMENTO

  const handleAceptarEliminar = () => {
    setOpenDlgConfirm(false);
    borrarDocumento({ variables: { referencia: formValues.Formulario, talonario: formValues.Talonario, idArchivo: 0 } });
  };

  const handleCancelarEliminar = () => {
    setOpenDlgConfirm(false);
  };

  const MBorrarDocumento = gql`
        mutation MBorrarDocumento ($referencia: String!, $talonario: String!, $idArchivo: Int!) {
            borrarDocumento 
            (
                referencia: $referencia,
                talonario: $talonario,
                idArchivo: $idArchivo
            )
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [borrarDocumento, { data: dataBorrarDocumento }] = useMutation(MBorrarDocumento, {
    onCompleted: (dataBorrarDocumento) => {
      if (dataBorrarDocumento.borrarDocumento.success) {
        // se eliminó el documento
        if (dataBorrarDocumento.borrarDocumento.valorEsperado) {
          // se debería volver a consultar los documentos, pero se sabe que
          // solo puede haber como máximo 1 documento, por lo tanto para no volver
          // a consultar a la base sin sentido directamente seteamos los datos para la grilla en null
          setData([]);
        } else {
          toast.error(dataBorrarDocumento.borrarDocumento.error);
          toast.dismiss(toastId);
        }
      } else {
        setMensajeError(dataBorrarDocumento.borrarDocumento.error);
        toast.dismiss(toastId);
      }
    },
    onError: (dataBorrarDocumento) => {
      setMensajeError("ERRORDB");
      toast.dismiss(toastId);
    }
  });

  const handleBorrar = () => {
    setShowGrilla(false);
    setAccion('BORRAR');
    getArchivo(formValues.Formulario, formValues.Talonario);
  };

  // FIN - ELIMINAR DOCUMENTO

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
    clickClear();
  };

  const handleView = () => {
    setShowGrilla(false);
    setAccion('VIEW');
    getArchivo(formValues.Formulario, formValues.Talonario);
  };

  const linkDescarga = () => {
    setShowGrilla(false);
    setAccion('DOWNLOAD');
    getArchivo(formValues.Formulario, formValues.Talonario);
  };

  const initialColumns = [
  {
    field: 'idArchivo',
    headerName: 'Id'
  },
  {
    field: 'titulo',
    headerName: 'Nombre'
  },
  {
    field: 'fechaAlta',
    headerName: 'Fecha'
  },
  {
    field: 'actions', headerName: 'Acciones', sortable: false,
    renderCell: (params) =>
    <>
                    <VisibilityIcon
        sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
        onClick={() => handleView()}
        titleAccess='Visualizar' />
                    <DeleteOutlineIcon
        sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt', marginLeft: '15px' }}
        onClick={() => handleBorrar()}
        titleAccess='Borrar' />
                    <button onClick={() => linkDescarga()} style={{ border: 'none', background: 'none' }}>
                        <DownloadIcon
          sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt', marginLeft: '15px', paddingTop: '5px' }}
          titleAccess='Descargar' />
                    </button>
                 </>

  }];


  const columns = generateColumnsDefaultConfiguration(initialColumns);

  return (
    <>
            <FormControl variant="outlined" sx={{ display: 'block', alignItems: 'center' }} fullWidth>
                <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center">
                    <div className="documento-encabezado" style={{ color: '#0063BE' }}>Visitas / Evoluciones Médicas / Resúmen de Ingreso</div>
                    <TextField
            className="input-40"
            inputProps={{ style: { textTransform: "uppercase" }, maxLength: 4 }}
            inputRef={textInputFormulario}
            label="Ref. Formulario"
            name="Formulario"
            onChange={handleChangeFormulario}
            required
            size="small"
            type="text"
            value={formValues.Formulario}
            variant="outlined" />
          
                    <br></br>
                    <TextField
            className="input-40"
            id="outlined-basic"
            inputProps={{ style: { textTransform: "uppercase" }, maxLength: 10 }}
            label="Nro. de Talonario"
            onBlur={handleBlurTalonario}
            onChange={handleChangeTalonario}
            name="Talonario"
            required
            size="small"
            type="text"
            value={formValues.Talonario}
            variant="outlined" />
          
                    <br />
                    <div>
                        <CustomButton disabled={disabledBtnValidar} variant="contained" endIcon={<CheckIcon />} onClick={clickCheck}>
                            Validar
                        </CustomButton>&nbsp;&nbsp;
                        <Button variant="contained" endIcon={<CloseIcon />} onClick={clickClear}>
                            Cancelar
                        </Button>
                    </div>

                    <br />

                    <div style={{ display: 'flex', fontSize: '11pt', textAlign: 'center' }}>
                        <label style={{ fontWeight: 'bold', color: '#818181' }}>Resultado: </label>&nbsp;
                        <label id="lblResult" style={{ color: colorMsg }}>{result}</label>
                    </div>

                    {showGrilla &&
          <>
                            <br />
                            <label htmlFor="icon-button-file" style={{ marginTop: '-15px' }}>
                                <Input accept="image/jpeg,image/jpg,image/jfif,image/png,application/pdf" onChange={handleChangeFile} id="icon-button-file" type="file" />
                                <IconButton color="primary" aria-label="upload picture" component="span" size='large'>
                                    <CloudUploadIcon fontSize="inherit" />
                                </IconButton>
                            </label>
                            <br />
                            <div style={{ width: '100%' }}>
                            <DataGridGenerico
                columns={columns}
                id="DataRef"
                rows={data}
                toolbar={false}>
              </DataGridGenerico>
                            </div>
                        </>
          }

                    {result === RESULTADO_VALIDACION_OK && !showGrilla &&
          <div class="loadingFullPage">
                            <div><CircularProgress disableShrink /><br />Cargando...</div>
                        </div>
          }


                </Grid>

            </FormControl>

            {openDlg && <DocumentViewer data={filePreview} setOpenDlg={setOpenDlg} />}

            <CustomDialog
        maxWidth="md"
        open={openDlgConfirm}
        title='Documento asociado'
        onCancel={handleCancelarEliminar}
        onAccept={handleAceptarEliminar}>
        
                ¿<strong>Está seguro de eliminar</strong> el documento seleccionado?.
            </CustomDialog>

            <ErrorDialog
        id="dlg-error-referenciados"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
        </>);

}